import { Outlet } from 'react-router'
import { PageProps } from '../../../Components/Page/types'
import Page from '../../AuthBaseLayout/Components/Page'

export const HomeLayoutPage = ({ children, ...props }: PageProps) => {
  return (
    <Page
      {...props}
      // leftContent={[
      //   <Breadcrumb key="breadcrumb">
      //     <BreadcrumbItem>Welcome To Studio</BreadcrumbItem>
      //     {props?.leftBreadcrumbs}
      //   </Breadcrumb>,
      //   ...props?.leftContent || []
      // ]}
      // rightContent={[
      //   <Typography.Text style={{ fontSize: '1rem', marginRight: 10 }}>Hi {auth?.user?.first_name}</Typography.Text>
      // ]}
    >
      {children}
      <Outlet />
    </Page>
  )
}
